

import { facebookLoginHandler } from "./platforms/facebook";
import { youtubeLoginHandler } from "./platforms/youtube";
import { instagramLoginHandler } from "./platforms/instagram";

export const handleSocialLogin = (platform, clientId) => {
  return new Promise((resolve, reject) => {
    switch (platform) {
      case "facebook":
        facebookLoginHandler(resolve, reject, clientId);
        break;
      case "youtube":
        youtubeLoginHandler(resolve, reject, clientId);
        break;
      case "instagram":
        instagramLoginHandler(resolve, reject, clientId);
        break;
      default:
        console.error("Platform not supported");
        reject(new Error("Platform not supported"));
    }
  });
};

